import { render } from "./PWalletSettings.vue?vue&type=template&id=e6169edc&scoped=true"
import script from "./PWalletSettings.vue?vue&type=script&lang=js"
export * from "./PWalletSettings.vue?vue&type=script&lang=js"

import "./PWalletSettings.vue?vue&type=style&index=0&id=e6169edc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6169edc"]])

export default __exports__